var _rect, _path, _circle, _circle2, _rect2, _rect3, _text, _rect4, _rect5, _circle3, _path2, _path3, _text2, _rect6, _rect7, _rect8, _text3, _rect9, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    rx: 48,
    fill: "#101114"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1200v760H0z",
    fill: "url(#grid)",
    opacity: 0.34
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 128,
    r: 230,
    fill: "#2DD4BF",
    opacity: 0.16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 622,
    r: 260,
    fill: "#F59E0B",
    opacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 112,
    width: 940,
    height: 536,
    rx: 36,
    fill: "#191B20",
    stroke: "rgba(255,255,255,.14)",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 160,
    width: 186,
    height: 54,
    rx: 14,
    fill: "#2DD4BF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 211,
    y: 196,
    fill: "#101114",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 28,
    fontWeight: 900
  }, "PickApp")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 260,
    width: 394,
    height: 284,
    rx: 28,
    fill: "rgba(255,255,255,.07)",
    stroke: "rgba(255,255,255,.13)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 626,
    y: 260,
    width: 394,
    height: 284,
    rx: 28,
    fill: "rgba(45,212,191,.12)",
    stroke: "rgba(45,212,191,.38)",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 402,
    r: 88,
    fill: "#2DD4BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323 402c26-34 82-34 108 0M344 451c18 13 47 13 66 0",
    stroke: "#101114",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M377 314v176M289 402h176",
    stroke: "#101114",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 670,
    y: 322,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 28,
    fontWeight: 900
  }, "Find a pickup game")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 362,
    width: 250,
    height: 16,
    rx: 8,
    fill: "#94A3B8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 402,
    width: 296,
    height: 16,
    rx: 8,
    fill: "#94A3B8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 454,
    width: 112,
    height: 38,
    rx: 19,
    fill: "#F59E0B"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 701,
    y: 480,
    fill: "#101114",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: 900
  }, "Join")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 582,
    width: 840,
    height: 18,
    rx: 9,
    fill: "rgba(255,255,255,.12)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 582,
    width: 590,
    height: 18,
    rx: 9,
    fill: "#2DD4BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 48,
    height: 48,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0v48",
    stroke: "white",
    strokeOpacity: 0.12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickapp);
export default __webpack_public_path__ + "static/media/pickapp.6d53b82d374147361267249fe2b32a43.svg";
export { ForwardRef as ReactComponent };